module.exports = __webpack_public_path__ + "static/media/fwdlook_logo.d69ca2c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FwdlookLogo/fwdlook_logo.svg
// module id = 568
// module chunks = 0